/**
 * Discord notifications via Parse Cloud (reckless-command-center).
 */
import Moralis from "moralis-v1";

export async function notifyDiscordTrade(payload) {
  return Moralis.Cloud.run("sendDiscordTradeNotification", payload);
}

export async function notifyDiscordBotReset(payload) {
  return Moralis.Cloud.run("sendDiscordBotResetNotification", payload);
}

/** Compact regime line for Discord / logs (keeps messages short). */
export function formatRegimeCompact(snap, book, cfg) {
  if (!snap?.regime) return null;
  const m4 = snap.metrics?.m4h;
  const m24 = snap.metrics?.m24h;
  const total = book?.totalBookUsd || 0;
  const wethPct = total > 0 ? ((book.holdingsUsd || 0) / total) * 100 : 0;
  const usdcPct = total > 0 ? ((book.baseBalance || 0) / total) * 100 : 0;
  const parts = [
    `regime=${snap.regime}`,
    snap.recoveryBreakoutActive ? "breakout=Y" : null,
    cfg?.adaptiveBuyMovePct != null
      ? `buy%=${(Number(cfg.adaptiveBuyMovePct) * 100).toFixed(2)}`
      : null,
    cfg?.adaptiveSellMovePct != null
      ? `sell%=${(Number(cfg.adaptiveSellMovePct) * 100).toFixed(2)}`
      : null,
    snap.consecBuys != null ? `consecBuys=${snap.consecBuys}` : null,
    m4?.sufficient ? `4hRng=${(m4.positionInRange * 100).toFixed(0)}%` : null,
    m24?.sufficient ? `24hDD=${(m24.drawdownFromHighPct * 100).toFixed(1)}%` : null,
    `WETH=${wethPct.toFixed(0)}%`,
    `USDC=${usdcPct.toFixed(0)}%`,
  ].filter(Boolean);
  return parts.join(" · ");
}
